export default {"src":"/_next/static/media/reset-password-logo.067d05a7.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};